const root = document.documentElement;
const headerEl = document.getElementById("header");
const heroEl = document.getElementById("hero");
// const geo = document.getElementById("geo");
const logo = document.getElementById("logo");
const secondaryLogo = document.getElementById("secondary_logo");

const scrollTriggerAnimationValue = 40;
let scrollDistance = 0;
let lenis;

// Create a MediaQueryList object
let sm = window.matchMedia("(min-width: 640px)");
let md = window.matchMedia("(min-width: 768px)");
let lg = window.matchMedia("(min-width: 1024px)");
let xl = window.matchMedia("(max-width: 1280px)");
let xxl = window.matchMedia("(max-width: 1536px)");

// Implement search capacity
window.axios = require("axios");
import Vue from "vue";
import Search from "./components/Search.vue";

Vue.config.productionTip = false;

new Vue({
  components: {
    Search,
  },
}).$mount("#vue-search");

addEventListener("resize", function (e) {
  checkMedia();
});
addEventListener("load", function (e) {
  updateClock();
  setInterval(updateClock, 1000);
  initSmoothScrolling();
  scroll();
  document.body.classList.replace("loading", "loaded");
});

const checkMedia = () => {
  if (!lg.matches) {
    headerEl.classList.remove("backdrop-blur-sm");
    // if (geo) geo.classList.remove("animated");
    logo.classList.remove("animated");
    secondaryLogo.classList.remove("animated");
  }
};

// Initializes Lenis for smooth scrolling with specific properties
const initSmoothScrolling = () => {
  lenis = new Lenis({
    lerp: 0.7, // Lower values create a smoother scroll effect
    smoothWheel: true, // Enables smooth scrolling for mouse wheel events
  });

  lenis.on("scroll", () => ScrollTrigger.update());

  const scrollFn = (time) => {
    lenis.raf(time);
    requestAnimationFrame(scrollFn);

    scrollDistance = lenis.actualScroll;

    if (lg.matches) {
      // run header, logo, clock animation for lg screen and above
      if (scrollDistance >= scrollTriggerAnimationValue) {
        headerEl.classList.add("backdrop-blur-sm");
        logo.classList.add("animated");
        // geo.classList.add("animated");
        secondaryLogo.classList.add("animated");
      } else {
        headerEl.classList.remove("backdrop-blur-sm");
        // if (geo) geo.classList.remove("animated");
        logo.classList.remove("animated");
        secondaryLogo.classList.remove("animated");
      }
    } else {
      // default state for header, logo, clock
      headerEl.classList.remove("backdrop-blur-sm");
      // if (geo) geo.classList.remove("animated");
      logo.classList.remove("animated");
    }

    window.lenis = lenis;

    // update the hero
    // heroEl.style.transform = `translateY(${1.1 * lenis.actualScroll}px)`;
  };

  requestAnimationFrame(scrollFn);
};

// Function to handle scroll-triggered animations
const scroll = () => {
  gsap
    .timeline({
      scrollTrigger: {
        trigger: heroEl,
        start: "65% center",
        // end: "bottom center",
        end: "+=30%",
        scrub: true,
        // markers: true,
      },
    })
    .to(
      heroEl,
      {
        ease: "none",
        opacity: 0,
        yPercent: 10,
      },
      0
    );
};

function updateClock() {
  let today = new Date();
  let h = today.getHours();
  let m = today.getMinutes();
  let s = today.getSeconds();
  var clockEl = document.getElementById("clock");
  m = checkTime(m);
  s = checkTime(s);
  if (clockEl)
    document.getElementById("clock").innerHTML = h + ":" + m + ":" + s;
  // setTimeout(updateClock, 1000);
}
function checkTime(i) {
  if (i < 10) {
    i = "0" + i;
  } // add zero in front of numbers < 10
  return i;
}
